import React from 'react';
import IconComponent from './icon';
import {
  getCurrentProject,
  getCurrentSector,
  getSessionTokenData
} from '../utils/userUtils';
import { roleTypes } from '../constants/role.constants';

export const menu = (t, companyState, userLang) => {
  const userSessionStorage = getSessionTokenData();

  const allowedCompanies = [721, 306, 272, 92, 572, 204];
  const allowedRoles = [
    roleTypes.SUPERADMIN,
    roleTypes.ADMIN,
    roleTypes.PROJECTLEADER,
    roleTypes.PLANNER
  ];

  const ARMAS_ORG_ID = 29;
  const INGEVEC_ORG_ID = 31;
  const PRODUCTIVITY_ORG_IDS = [ARMAS_ORG_ID, INGEVEC_ORG_ID];

  const svgIcon = (routeName) => <IconComponent name={routeName} />;

  const baseMenu = [
    {
      available: true,
      id: '0',
      title: t('modules.masterplan'),
      icon: 'pic-right',
      routeName: 'masterplan',
      go: (history) => {
        history.push('/masterplan');
      },
      svgIcon
    },
    {
      available: true,
      id: '1',
      title: t('modules.lookahead'),
      icon: 'pic-right',
      routeName: 'lookahead',
      go: (history) => {
        const project = getCurrentProject();
        const schedule = getCurrentSector();

        if (!companyState) {
          return history.push('/selectCompany');
        }

        if (!project || !schedule) {
          return history.push('/projects');
        }

        const url = `/${companyState.id}/project/${project.id}/schedule/${schedule.id}/lookahead`;
        history.push(url);
      },
      svgIcon
    },
    {
      available: true,
      id: '2',
      title: t('modules.weeklyplan'),
      icon: 'pic-right',
      routeName: 'weeklyplan',
      go: (history) => {
        history.push('/weeklyplan/commintments');
      },
      svgIcon
    }
  ];

  if (userLang.includes('es')) {
    baseMenu.push({
      available: true,
      id: '3',
      title: t('modules.taktplanning'),
      icon: 'pic-right',
      routeName: 'taktplanning',
      go: (history) => {
        history.push('/taktplanning/units');
      },
      svgIcon
    });
  }

  if (PRODUCTIVITY_ORG_IDS.includes(companyState?.id)) {
    baseMenu.push({
      available: true,
      id: '4',
      title: t('modules.productivity'),
      icon: 'pic-right',
      routeName: 'productivity',
      go: (history) => {
        history.push('/productivity/assign');
      },
      svgIcon
    });
  }

  if (
    userSessionStorage &&
    allowedRoles.includes(userSessionStorage.role) &&
    allowedCompanies.includes(parseInt(userSessionStorage.companyId))
  ) {
    baseMenu.push(
      {
        available: true,
        id: '9',
        title: t('modules.taktplanning'),
        icon: 'pic-right',
        routeName: 'taktplanning',
        go: (history) => {
          history.push('/taktplanning/units');
        },
        svgIcon
      },
      {
        available: true,
        id: '10',
        title: t('modules.takt_analytics'),
        icon: 'bar-chart',
        routeName: 'extraDashboard',
        go: (history) => {
          history.push('/extraDashboard');
        },
        svgIcon
      }
    );
  }

  baseMenu.push({
    available: true,
    id: '8',
    title: t('modules.analytics'),
    icon: 'bar-chart',
    routeName: 'analytics',
    go: (history) => {
      history.push('/analytics-v2');
    },
    svgIcon
  });

  return baseMenu;
};
